import { Record } from 'immutable';

import { resolve } from '../helpers/LinkMapper';


var Route = new Record({
    id: null,
    name: null,
    code: null,
    description: null
});

Route.fromJSON = function (json) {
    json = json || {};

    const name = resolve(json.name).with(String);
    const code = resolve(json.code).with(String);
    const description = resolve(json.description).with(String);

    let result = { name, code, description };

    return new Route(result);
};

export default Route;
